import { useMemo } from 'react';
import { useQuery } from 'convex/react';
import { api } from '../../convex/_generated/api'; // DEEP_IMPORT_JUSTIFIED: Convex generated API lives outside src/; no @convex/ path alias in tsconfig — all hooks in src/hooks/ use this relative path
import type { ISuperadminContext } from '@/@types/superadmin';

/**
 * Provides superadmin context for the current user.
 * Returns isSuperadmin flag and loading state.
 */
export function useSuperadminContext(): ISuperadminContext {
  const result = useQuery(api.superadmin.queries.checkSuperadmin);

  return useMemo(() => {
    if (result === undefined) {
      return { isSuperadmin: false, isLoading: true };
    }
    return { isSuperadmin: result.isSuperadmin, isLoading: false };
  }, [result]);
}
